window.PlummeI18n.register("no", {
  "manualPreview.reset": "Nullstill",
  "manualPreview.title": "Bokføring",
  "manualPreview.details": "Detaljer",
  "manualPreview.summary": "Oppsummering per konto",
  "manualPreview.date": "Dato",
  "manualPreview.account": "Konto",
  "manualPreview.vat": "MVA-kode",
  "manualPreview.before": "Saldo før",
  "manualPreview.amount": "Beløp",
  "manualPreview.after": "Saldo etter",
  "manualPreview.debit": "Debet",
  "manualPreview.credit": "Kredit",
  "manualPreview.net": "Nettoendring",
  "manualPreview.warning.balances": "Saldoer er ikke tilgjengelige fra regnskapsgrunnlaget. Føringene vises uten saldo før og etter.",
  "manualPreview.warning.editing": "Ved korrigering vises erstatningsføringen her. Saldo før og etter vises ikke, fordi korrigeringen også kan reversere et tidligere bilag.",
  "manualPreview.warning.years": "Føringene går over flere kalenderår. Bokføringslinjene vises, men saldo før og etter er ikke beregnet på tvers av år.",
  "manualPreview.warning.country": "Forhåndsvisningen mangler regnskapsland eller støtter ikke den valgte MVA-behandlingen for landet."
});
